<div class="team-leader-edit">
  <div class="team-leader-edit__content">
    <div class="team-leader-edit__layout">
      <div class="team-leader-edit__header">
        <div class="team-leader-edit__heading">
          <h1 class="page-title">Edit Team Leader</h1>
          <p class="page-subtitle">Update team leader information, address details, and partner assignments.</p>
        </div>
        <div class="team-leader-edit__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button
            type="button"
            [disabled]="isSaving || teamLeaderForm.invalid || !teamLeaderId || !isReady"
            (click)="saveTeamLeader()">
            {{ isSaving ? "Saving..." : "Save changes" }}
          </app-button>
        </div>
      </div>

      @if (isReady) {
      <app-card>
        <form [formGroup]="teamLeaderForm" class="team-leader-edit__form">
          <div class="team-leader-edit__form-grid">
            <div class="team-leader-edit__form-field">
              <div class="team-leader-edit__form-label-row">
                <label for="name" class="team-leader-edit__form-label">Name</label>
              </div>
              <input
                id="name"
                type="text"
                formControlName="name"
                autocomplete="off"
                class="team-leader-edit__form-input"
                [class.team-leader-edit__form-input--error]="teamLeaderForm.get('name')?.invalid && teamLeaderForm.get('name')?.touched" />
              @if (teamLeaderForm.get('name')?.invalid && teamLeaderForm.get('name')?.touched) {
              <div class="team-leader-edit__form-error">Name is required and must be at least 2 characters</div>
              }
            </div>

            <div class="team-leader-edit__form-field">
              <div class="team-leader-edit__form-label-row">
                <label for="email" class="team-leader-edit__form-label">Email</label>
              </div>
              <input id="email" type="email" formControlName="email" autocomplete="off" class="team-leader-edit__form-input" />
            </div>
          </div>

          <div class="team-leader-edit__form-grid">
            <div class="team-leader-edit__form-field">
              <div class="team-leader-edit__form-label-row">
                <label for="phone" class="team-leader-edit__form-label">Phone</label>
              </div>
              <input id="phone" type="tel" formControlName="phone" autocomplete="off" class="team-leader-edit__form-input" />
            </div>

            <div class="team-leader-edit__form-field">
              <div class="team-leader-edit__form-label-row">
                <label for="partners" class="team-leader-edit__form-label">Partners</label>
              </div>
              <div class="team-leader-edit__partner-autocomplete">
                <app-autocomplete
                  [prefetchOnInit]="false"
                  id="partners"
                  [options]="searchedPartners"
                  placeholder="Search partners..."
                  [minLength]="2"
                  [debounceMs]="300"
                  [multiSelect]="true"
                  [selectedValues]="selectedPartnerIds"
                  (searchChange)="searchPartners($event)"
                  (selectionChange)="onPartnerChange($event)" />
              </div>
            </div>
          </div>
        </form>
      </app-card>

      <app-card class="team-leader-edit__address-card">
        <div class="team-leader-edit__section-header">
          <div>
            <h2 class="team-leader-edit__section-title">Address Information</h2>
            <p class="team-leader-edit__section-hint">Update the location hierarchy and address details.</p>
          </div>
        </div>

        <app-location-selector [value]="addressValue" (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
      }
    </div>
  </div>
</div>
